var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon5Card2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33324 1.33301V5.33301C9.33314 5.55666 9.38931 5.77675 9.49657 5.97301L13.1699 12.693C13.281 12.8961 13.3373 13.1246 13.3333 13.356C13.3293 13.5875 13.2652 13.8139 13.1471 14.013C13.0291 14.2121 12.8612 14.3771 12.66 14.4916C12.4589 14.6062 12.2314 14.6664 11.9999 14.6663H3.9999C3.76842 14.6664 3.54091 14.6062 3.33976 14.4916C3.13861 14.3771 2.97075 14.2121 2.8527 14.013C2.73464 13.8139 2.67046 13.5875 2.66646 13.356C2.66246 13.1246 2.71879 12.8961 2.8299 12.693L6.50324 5.97301C6.6105 5.77675 6.66666 5.55666 6.66657 5.33301V1.33301",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.302 10H11.698",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66675 1.33301H10.3334",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5Card2);
export default __webpack_public_path__ + "static/media/Icon5card2.53835cef8ddf09dfc0c79a36df589401.svg";
export { ForwardRef as ReactComponent };